import {
    EDIT_PAGE,
    RESET_PAGE,
    TOGGLE_CUSTOMIZE_PAGE,
    UPDATE_PAGE,
    UPDATE_PAGE_FAIL,
    UPDATE_PAGE_SUCCESS,
} from './reducer';

export const createPage = (data) => ({
    payload: {
        request: {
            data,
            method: 'post',
            url: '/pages',
        },
    },
    types: [UPDATE_PAGE, UPDATE_PAGE_SUCCESS, UPDATE_PAGE_FAIL],
});

export const updatePage = (data) => ({
    payload: {
        request: {
            data,
            method: 'put',
            url: `/pages/${data.get('id')}`
        },
    },
    types: [UPDATE_PAGE, UPDATE_PAGE_SUCCESS, UPDATE_PAGE_FAIL],
});

export const savePage = (data) => (dispatch) => {
    return data.get('id')
        ? dispatch(updatePage(data))
        : dispatch(createPage(data));
};

export const editPage = (field, value) => ({
    field,
    type: EDIT_PAGE,
    value
});

export const resetPage = () => ({ type: RESET_PAGE });

export const toggleCustomizePage = () => ({ type: TOGGLE_CUSTOMIZE_PAGE });
